import { Box, Typography, Paper } from '@mui/material';
import ShareItems from '../Company/ShareItems';

export default function EmptyState() {
  return (
    <Box
      sx={{
        borderRadius: '12px',
        height: '100%',
      }}
    >
      <Paper
        elevation={1}
        sx={{
          height: '100%',
          padding: '48px 32px',
          borderRadius: '12px',
          width: '100%',
          boxShadow: 'none',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        <Box
          component="img"
          src="/images/activity-empty-state.png"
          alt="Empty State"
          style={{
            width: { xxs: null, sm: '100%' },
            height: '100%',
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            margin: '0 auto',
            opacity: 0.1,
          }}
        />
        <Typography
          sx={{
            mb: 2,
            fontWeight: '700',
            fontSize: '28px',
            lineHeight: '40px',
            color: '#232B35',
          }}
        >
          This is where your ideas & introductions from your advisors will
          appear.
        </Typography>
        <Typography
          sx={{
            mb: 2,
            fontWeight: '400',
            fontSize: '20px',
            lineHeight: '40px',
            color: '#232B35',
          }}
        >
          So start inviting people to your advisory board! The bigger your
          board, the more ideas and advocates for you.
        </Typography>
        <Typography
          sx={{
            mb: 2,
            fontWeight: '700',
            fontSize: '20px',
            lineHeight: '40px',
            color: '#232B35',
          }}
        >
          Click below to start turning contacts into followers:
        </Typography>
        <ShareItems />
      </Paper>
    </Box>
  );
}
